<form id="reference-information" [formGroup]="regForm" (ngSubmit)="step10Submitted(regForm)" novalidate>


 
  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large;">Reference Information</label>
  
  </div><br><br>
  


  <div>

    <div class="container-fluid" style="height:25px; background-color: #0079c1; color: white; " >Reference 1
      </div>
    <div class="form-row" style="height:25px;"></div>







    <div class="form-row">


      <div class="form-group col-lg-6 col-md-6  col-sm-6" >
        <label style="font-weight: bold;">Reference Name (reference from your previous company):</label>
        <input type="text" class="form-control" for="ReferenceName"  formControlName="ReferenceName" id="ReferenceName" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
      </div>


      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>Relationship To Person:</label>
        <input type="text" class="form-control" for="ReferenceSupervisor"  formControlName="ReferenceSupervisor" id="ReferenceSupervisor" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>



    </div>

    <div class="form-row">



      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>Address:</label>
        <input type="text" class="form-control" for="ReferenceAddress"  formControlName="ReferenceAddress" id="ReferenceAddress" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>



      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>Telephone:</label>
        <input type="text" class="form-control" for="ReferenceTelephone"  formControlName="ReferenceTelephone" id="ReferenceTelephone" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000' >
      </div>


      
    </div>


    <div class="form-row">



      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>E-Mail:</label>
        <input type="text" class="form-control" for="ReferenceEmail"  formControlName="ReferenceEmail" id="ReferenceEmail" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>



      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>Fax:</label>
        <input type="text" class="form-control" for="ReferenceFax"  formControlName="ReferenceFax" id="ReferenceFax" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000' >
      </div>



      
    </div>






    <div class="form-row" style="height:50px;"></div>




    <div class="container-fluid" style="height:25px; background-color: #0079c1; color: white;" >Reference 2</div>
    <div class="form-row" style="height:25px;"></div>



  


    <div class="form-row">

      <div class="form-group col-lg-6 col-md-6  col-sm-6" >
        <label style="font-weight: bold;">Reference Name (reference from your previous company):</label>
        <input type="text" class="form-control" for="ReferenceName1"  formControlName="ReferenceName1" id="ReferenceName1" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
      </div>


      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>Relationship To Person:</label>
        <input type="text" class="form-control" for="ReferenceSupervisor1"  formControlName="ReferenceSupervisor1" id="ReferenceSupervisor1" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>


    </div>


    <div class="form-row">

      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>Address:</label>
        <input type="text" class="form-control" for="ReferenceAddress1"  formControlName="ReferenceAddress1" id="ReferenceAddress1" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>



      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>Telephone:</label>
        <input type="text" class="form-control" for="ReferenceTelephone1"  formControlName="ReferenceTelephone1" id="ReferenceTelephone1" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000'>
      </div>

      
    </div>


    <div class="form-row">

      
      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>E-Mail:</label>
        <input type="text" class="form-control" for="ReferenceEmail1"  formControlName="ReferenceEmail1" id="ReferenceEmail1" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>



      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>Fax:</label>
        <input type="text" class="form-control" for="ReferenceFax1"  formControlName="ReferenceFax1" id="ReferenceFax1" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000'>
      </div>
    </div>







    <div class="form-row" style="height:50px;"></div>

    <div class="container-fluid" style="height:25px; background-color:#0079c1; color: white;" >Reference 3</div>
    <div class="form-row" style="height:25px;"></div>






    <div class="form-row">
      <div class="form-group col-lg-6 col-md-6  col-sm-6" >
        <label style="font-weight: bold;">Reference Name (reference from your previous company):</label>
        <input type="text" class="form-control" for="ReferenceName2"  formControlName="ReferenceName2" id="ReferenceName2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
      </div>


      <div class="form-group col-lg-4 col-md-4  col-sm-4" >
        <label>Relationship To Person:</label>
        <input type="text" class="form-control" for="ReferenceSupervisor2"  formControlName="ReferenceSupervisor2" id="ReferenceSupervisor2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>



    </div>

    <div class="form-row">


      <div class="form-group col-lg-6 col-md-6  col-sm-6" >
        <label>Address:</label>
        <input type="text" class="form-control" for="ReferenceAddress2"  formControlName="ReferenceAddress2" id="ReferenceAddress2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>



      <div class="form-group col-lg-4 col-md-4  col-sm-4" >
        <label>Telephone:</label>
        <input type="text" class="form-control" for="ReferenceTelephone2"  formControlName="ReferenceTelephone2" id="ReferenceTelephone2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000'>
      </div>


    </div>

    <div class="form-row">



      <div class="form-group col-lg-6 col-md-6  col-sm-6" >
        <label>E-Mail:</label>
        <input type="text" class="form-control" for="ReferenceEmail2"  formControlName="ReferenceEmail2" id="ReferenceEmail2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>



      <div class="form-group col-lg-4 col-md-4  col-sm-4" >
        <label>Fax:</label>
        <input type="text" class="form-control" for="ReferenceFax2"  formControlName="ReferenceFax2" id="ReferenceFax2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000'>
      </div>

    </div>




</div>



<br>



<br/>

<button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>Prev Page</button>
&nbsp;
<button type="submit"  class="btn btn-primary" >Save and Continue &nbsp;
<i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   



<div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> Saving Data...</i>



</form>